import React, { Fragment, useState } from 'react';
import { GET_ONE, UPDATE_MANY } from 'ra-core';
import { Button, useDataProvider, downloadCSV, useTranslate, useListContext, useUnselectAll } from 'react-admin';
import CheckIcon from '@mui/icons-material/Check';
import DoneIcon from '@mui/icons-material/Done';
import ErrorIcon from '@mui/icons-material/Error';
import { unparse as convertToCSV } from 'papaparse/papaparse.min';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { FUNCTION_URL } from '../../../Constants/index';
import ResultDialog from '../../../Utilities/ResultDialog';

function ValidateRegmanBulk() {
    const [isOpen, setIsOpen] = useState(false);
    const [resultDialogOpen, setResultDialogOpen] = useState(false);
    const [resultDialogHeaders, setResultDialogHeaders] = useState([]);
    const [resultDialogRows, setResultDialogRows] = useState([[]]);
    const [resultLoading, setResultLoading] = useState(false);
    const [resultDialogTitle, setResultDialogTitle] = useState('');

    const { selectedIds } = useListContext();

    const dataProvider = useDataProvider();
    const translate = useTranslate();
    const unselectAll = useUnselectAll("devices");

    const handleClick = () => {
        setIsOpen(true);
    }

    const handleDialogClose = () => {
        setIsOpen(false);
    };

    const handleConfirm = async () => {
        setIsOpen(false);
        setResultDialogOpen(true);
        setResultLoading(true);
        setResultDialogTitle('In aggiornamento...');

        //Check all Ids statuses and ignore the ones that aren't 3
        var validIds = [];
        var invalidDevices = [];
        if (selectedIds.length > 10) {
            setResultDialogOpen(true);
            setResultDialogHeaders(["Aggiornamento Regman"]);
            setResultDialogRows([["Sono stati selezionati più item di quelli consentiti dalla funzione massiva"]]);
            setResultDialogTitle('Risultato');
            setResultLoading(false);
        }
        await asyncForEach(selectedIds, async (response) => {
            let nonRegmanNMUs = localStorage.getItem('nonRegmanNMUs') ? localStorage.getItem('nonRegmanNMUs').split(',') : [];
            if (response.data.error) {
                //Ex: Invalid cast Id
                console.log(response.data.error.message);
            }
            else if (response.data.message) {
                //Ex: No entries found
                console.log("id: " + response.data.id + "; Message: " + response.data.message);
            }
            else if (response.data.status && response.data.status.codice === '3' && response.data.status_regman.codice === '0'
                && !nonRegmanNMUs.includes(response.data.cod_nmu.toString()) && response.data.flag_olo != "SI" && !response.data.progetto_con_scarico && response.data.cod_terr_sap !== "IMCNS093"
                && (!response.data.status_collaudo_one || ['0', '2'].includes(response.data.status_collaudo_one.codice))) {
                validIds.push(response.data);
            }
            else {
                //Create a list of the ones that will not be updated
                invalidDevices.push(response.data);
            }
        });
        var resultArray = [];
        await asyncGetInfoCPE(validIds, async (response) => {
            if (response && response.result === 'OK') {
                resultArray.push([response.serial_number_tim, response.status_descrizione, response.status_regman_descrizione, <DoneIcon />, ""]);
            }
            else if (response && response.result !== 'OK') {
                resultArray.push([response.serial_number_tim, response.status_descrizione, response.status_regman_descrizione, <ErrorIcon />, "Il Sistema Regman ha risposto con un errore"]);
            }
            else {
                resultArray.push([response.serial_number_tim, '', '', <ErrorIcon />, "Il Sistema Regman non è disponibile"]);
            }
        });

        // add the ones that we didn't updated because of wrong status
        invalidDevices.map(device => {
            resultArray.push([device.serial_number_tim, device.status.descrizione, device.status_regman.descrizione, <ErrorIcon />, translate('tim.validateregmanbulk.notValid')]);
        });
        setResultDialogOpen(true);
        setResultDialogHeaders(["Apparato", "Stato", "Stato Regman", "Risultato", "Dettaglio"]);
        setResultDialogRows(resultArray);
        setResultDialogTitle('Risultati');
        setResultLoading(false);
        unselectAll();
    };

    const asyncForEach = async (array, callback) => {
        for (let index = 0; index < array.length; index++) {
            //await callback(array[index], index, array);
            await dataProvider(GET_ONE, 'devices', { id: array[index] })
                .then(
                    response => {
                        if (response.data.message) {
                            callback(response);
                        }
                        else {
                            callback(response);
                        }
                    })
                .catch(error => {
                    callback(error);
                });
        }
    };

    const asyncGetInfoCPE = async (array, callback) => {
        for (let index = 0; index < array.length; index++) {
            //await callback(array[index], index, array);
            await fetch(FUNCTION_URL + '/getinfocpe/' + array[index].id, {
                method: 'GET',
                headers: {
                    'x-zumo-auth': localStorage.getItem('auth-token')
                }
            })
                .then(
                    async response => {
                        if (response.status === 200) {
                            await response.text()
                                .then(text => {
                                    if (text !== '') {
                                        let body = JSON.parse(text);
                                        body['id'] = array[index].id;
                                        body['serial_number_tim'] = array[index].serial_number_tim;
                                        callback(body);
                                    }
                                })
                        }
                        else {
                            let body = {
                                id: array[index].id,
                                serial_number_tim: array[index].serial_number_tim,
                                result: 'KO',
                                message: 'Il Sistema Regman non è disponibile'

                            }
                            callback(body);
                        }
                    })

                .catch(error => {
                    callback(error);
                });
        }
    }

    const handleResultClose = () => {
        setResultDialogOpen(false);
        setResultDialogHeaders([]);
        setResultDialogRows([[]]);
        unselectAll();
    }

    const exportToCSV = () => {
        const resultForExport = resultDialogRows.map(row => {
            const { ...resultForExport } = {};
            resultForExport.Apparato = row[0];
            resultForExport.Stato = row[1];
            resultForExport.Risultato = row[4] === "" ? "OK" : "KO";
            resultForExport.Errore = row[4];
            return resultForExport;
        })
        const csv = convertToCSV({
            data: resultForExport,
            fields: resultDialogHeaders
        });
        downloadCSV(csv, 'Risultati');
    }


    return (
        <Fragment>
            <Button label='tim.validateregmanbulk.button_label' onClick={handleClick} >
                <CheckIcon />
            </Button>
            <Dialog
                open={isOpen}
                onClose={handleDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{translate('tim.validateregmanbulk.title')}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        {translate('tim.validateregmanbulk.content')}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleDialogClose} label='tim.validateregmanbulk.cancel' color="primary" autoFocus />
                    <Button onClick={handleConfirm} label='tim.validateregmanbulk.confirm' color="primary" autoFocus />
                </DialogActions>
            </Dialog>
            <ResultDialog
                open={resultDialogOpen}
                rows={resultDialogRows}
                headers={resultDialogHeaders}
                loading={resultLoading}
                title={resultDialogTitle}
                onClose={handleResultClose} >
                {!resultLoading && <Button label='tim.validateregmanbulk.export' onClick={exportToCSV} color="primary"></Button>}
                {!resultLoading && <Button label='tim.validateregmanbulk.close' onClick={handleResultClose} color="primary"></Button>}
            </ResultDialog>
        </Fragment>
    );
}
export default ValidateRegmanBulk;